/**
 * Zentrales Debug-Logging fürs Frontend-Bundle.
 * Gibt nur dann etwas in der Browser-Konsole aus, wenn der Debug-Modus
 * (Hauptmenü > Debug) im Plugin aktiviert ist (window.pixelmateConfig.debug).
 */
function isDebugEnabled() {
    return !!(window.pixelmateConfig && window.pixelmateConfig.debug);
}

export function pmLog(...args) {
    if (isDebugEnabled()) {
        console.log('[Pixelmate]', ...args);
    }
}

export function pmWarn(...args) {
    if (isDebugEnabled()) {
        console.warn('[Pixelmate]', ...args);
    }
}

export function pmError(...args) {
    if (isDebugEnabled()) {
        console.error('[Pixelmate]', ...args);
    }
}

